<template>
  <div class="container-login">
    



<form style="max-width:330px;display:block;margin:0 auto;" @submit.prevent.stop="autenticar">
  <img src="/img/logo_login.jpg" class="img-responsive" />
  <div class="form-group">
    <label for="exampleInputEmail1">Login</label>
    <input type="text" class="form-control" v-model="login">
  </div>

  <div class="form-group">
    <label for="exampleInputPassword1">Senha</label>
    <input type="password" class="form-control" v-model="senha">
  </div>


  <button type="submit" class="btn btn-primary btn-block" style="background-color:#4c1c17 !important;border-color:#4c1c17;">ENTRAR</button>
</form>





  </div>
</template>

<script>
import axios from 'axios'

export default {

  name: 'Login',
  components: {},
  data(){
    return {
      login:'',
      senha:'',
      dados:{}
    }
  },

  methods:{
    logar(){


      if(this.dados.permissao == 0){
        sessionStorage.clear();
        alert("Login ou senha incorretos!");
      }else{
        console.log(this.dados)
        sessionStorage.setItem('imobiliaria', this.dados.permissao);
        sessionStorage.setItem('imobiliariaNome', this.dados.nome);
        sessionStorage.setItem('imobiliariaID', this.dados.id);
        switch(Number(this.dados.permissao)){
           case 1:
            this.$router.push("/busca"); 
          break;
          case 2:
            this.$router.push("/busca"); 
          break;
          case 3:
            this.$router.push("/cadastro"); 
          break;
           case 4:
            this.$router.push("/busca"); 
          break;
        }
       
       
      }


      
    },


     autenticar(){
          
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/autenticar',{login:this.login,senha:this.senha})
          .then(response => {this.dados = response.data;this.logar()} )
          .catch(response => console.log(response))
          
    },
  }
}
</script>
